import { api } from './client'

export interface NotificationSettings {
    id: string
    store_id: string
    new_order_enabled: boolean
    overdue_enabled: boolean
    stock_low_enabled: boolean
    active_from: string
    active_to: string
}

export interface UpdateNotificationSettingsRequest {
    new_order_enabled: boolean
    overdue_enabled: boolean
    stock_low_enabled: boolean
    active_from: string
    active_to: string
}

export const notificationSettingsApi = {
    getSettings: () =>
        api.get<NotificationSettings>('/admin/notification/settings'),

    updateSettings: (data: UpdateNotificationSettingsRequest) =>
        api.put<NotificationSettings>('/admin/notification/settings', data),
}
